import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import HeroBike from "../Images/bike1.png";
import SecondaryBike from "../Images/bike2.png";
import Logo from "../Images/logowhite.svg";

const services = [
  {
    title: "CBD Express Dispatch",
    description:
      "Urgent same-day bike deliveries for documents, packages, and office essentials across Nairobi CBD.",
  },
  {
    title: "Business Route Programs",
    description:
      "Scheduled pickups and drop-offs for corporates, legal firms, pharmacies, and retail operations.",
  },
  {
    title: "Live Fleet Visibility",
    description:
      "Real-time order progression from pickup request to completed delivery through one operations system.",
  },
];

const aboutHighlights = [
  {
    title: "Built For Nairobi CBD",
    text: "Our dispatch model is tuned for dense city traffic and short-window urban deliveries.",
  },
  {
    title: "Technology + Operations",
    text: "Customers place orders directly while dispatch teams manage assignments and completion at scale.",
  },
  {
    title: "Reliable Last-Mile Team",
    text: "A dedicated bike fleet and operations desk designed for professional, business-critical deliveries.",
  },
];

const contactItems = [
  {
    title: "Operations Desk",
    value: "Nairobi CBD, Kenya",
    detail: "Mon - Sun | 7:00 AM - 9:00 PM",
  },
  {
    title: "Email",
    value: "support@dropoffmtaani.com",
    detail: "For onboarding, billing, and support",
  },
  {
    title: "Phone",
    value: "+254 700 000 000",
    detail: "Direct dispatch and support line",
  },
];

function LandingPage() {
  return (
    <div className="landing-page">
      <div className="lp-background-glow lp-glow-one" />
      <div className="lp-background-glow lp-glow-two" />

      <header className="lp-header lp-fade-in">
        <div className="lp-brand">
          <img src={Logo} alt="Dropoff Mtaani" className="lp-logo" />
        </div>

        <nav className="lp-nav">
          <a href="#about">About Us</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact Us</a>
          <a href="#download">Download App</a>
        </nav>

        <div className="lp-header-actions">
          <Link to="/register" className="lp-link-btn">
            Create Account
          </Link>
          <Link to="/login" className="lp-cta-btn">
            Sign In
          </Link>
        </div>
      </header>

      <main className="lp-main">
        <section className="lp-hero lp-rise lp-delay-1">
          <div className="lp-hero-copy">
            <p className="lp-eyebrow">Nairobi CBD Bike Logistics</p>
            <h1>Minimal systems. Maximum delivery velocity.</h1>
            <p className="lp-subtext">
              A modern logistics platform where customers self-register and place
              orders instantly, while your operations team controls dispatch,
              trips, and completion from one admin command center.
            </p>

            <div className="lp-hero-actions">
              <Link to="/register" className="lp-btn-primary">
                Start As Customer
              </Link>
              <Link to="/login" className="lp-btn-secondary">
                Open Portal Login
              </Link>
            </div>

            <div className="lp-chip-row">
              <span>Self Signup</span>
              <span>Admin Control</span>
              <span>Live Tracking</span>
            </div>
          </div>

          <div className="lp-hero-visual">
            <div className="lp-route-card">
              <p>LIVE ROUTE</p>
              <h3>Kenyatta Ave to Upper Hill</h3>
              <span>Bike Courier | En Route</span>
            </div>
            <img src={HeroBike} alt="Bike courier" className="lp-bike" />
            <img src={SecondaryBike} alt="Bike courier" className="lp-bike-shadow" />
          </div>
        </section>

        <section id="about" className="lp-about lp-rise lp-delay-2">
          <div className="lp-section-head">
            <p>About Us</p>
            <h2>Executive bike logistics with local city intelligence.</h2>
          </div>

          <div className="lp-about-grid">
            {aboutHighlights.map((item) => (
              <article key={item.title} className="lp-about-card">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="services" className="lp-services lp-rise lp-delay-3">
          <div className="lp-section-head">
            <p>Services</p>
            <h2>Designed for serious businesses operating in Nairobi CBD.</h2>
          </div>

          <div className="lp-service-grid">
            {services.map((service) => (
              <article key={service.title} className="lp-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="download" className="lp-download lp-rise lp-delay-4">
          <div className="lp-download-copy">
            <p>Download App</p>
            <h2>Order from your phone. Track every step in real time.</h2>
            <p className="lp-subtext">
              Install the customer app experience and dispatch deliveries in
              seconds for your business team.
            </p>
            <div className="lp-download-actions">
              <a href="#download" className="lp-store-btn">
                Google Play
              </a>
              <a href="#download" className="lp-store-btn">
                App Store
              </a>
            </div>
          </div>
          <div className="lp-download-visual">
            <img src={SecondaryBike} alt="App delivery visual" />
          </div>
        </section>

        <section id="contact" className="lp-contact lp-rise lp-delay-5">
          <div className="lp-section-head">
            <p>Contact Us</p>
            <h2>Talk to our dispatch and onboarding team.</h2>
          </div>

          <div className="lp-contact-grid">
            {contactItems.map((item) => (
              <article key={item.title} className="lp-contact-card">
                <p className="lp-contact-title">{item.title}</p>
                <h3>{item.value}</h3>
                <span>{item.detail}</span>
              </article>
            ))}
          </div>
        </section>
      </main>

      <footer className="lp-footer lp-rise lp-delay-6">
        <div className="lp-footer-top">
          <div className="lp-footer-brand">
            <img src={Logo} alt="Dropoff Mtaani" />
            <p>
              Premium bike logistics for Nairobi CBD businesses, built for speed,
              visibility, and reliable last-mile execution.
            </p>
          </div>

          <div className="lp-footer-links">
            <h4>Quick Links</h4>
            <a href="#about">About Us</a>
            <a href="#services">Services</a>
            <a href="#contact">Contact Us</a>
            <a href="#download">Download App</a>
          </div>

          <div className="lp-footer-portal">
            <h4>Portal Access</h4>
            <Link to="/register">Customer Registration</Link>
            <Link to="/login">Sign In</Link>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <p>© {new Date().getFullYear()} Dropoff Mtaani. All rights reserved.</p>
          <span>Nairobi CBD, Kenya</span>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
